/**
 * Fime – Hero Tab Slider
 *
 * NOTE: this module is not yet wired to any markup (Hero section comes
 * in a later milestone step). The guard below prevents errors on pages
 * where .hero-tab elements don't exist yet.
 */

document.addEventListener('DOMContentLoaded', () => {
        const tabs = document.querySelectorAll('.hero-tab');
        const backgrounds = document.querySelectorAll('.hero-bg');
        const pill = document.getElementById('active-pill');
        const activeHeadingEl = document.getElementById('hero-active-heading');
        const activeCtaEl = document.getElementById('hero-active-cta');
        const activeCtaTextEl = document.getElementById('hero-active-cta-text');
        const slidesData = document.querySelectorAll('#hero-slides-data > div');

        if (!tabs.length || !pill) return;

        let currentIndex = 0;
        let slideInterval;
        const intervalTime = 5000;

        function updateSlideContent(index) {
                const data = slidesData[index];
                if (!data) return;

                const headingSrc = data.querySelector('.hero-slide-heading-src');
                const ctaTextSrc = data.querySelector('.hero-slide-cta-text-src');

                if (activeHeadingEl && headingSrc) {
                        activeHeadingEl.textContent = headingSrc.textContent;
                }
                if (activeCtaTextEl && ctaTextSrc) {
                        activeCtaTextEl.textContent = ctaTextSrc.textContent;
                }
                if (activeCtaEl) {
                        activeCtaEl.href = data.dataset.ctaUrl || '/#home-offer';
                        if (data.dataset.ctaTarget) {
                                activeCtaEl.setAttribute('target', data.dataset.ctaTarget);
                        } else {
                                activeCtaEl.removeAttribute('target');
                        }
                }
        }

        function updateSlider(index) {
                backgrounds.forEach((bg, i) => {
                        if (i === index) {
                                bg.classList.remove('opacity-0');
                                bg.classList.add('opacity-100');
                        } else {
                                bg.classList.remove('opacity-100');
                                bg.classList.add('opacity-0');
                        }
                });

                const activeTab = tabs[index];
                pill.style.width = `${activeTab.offsetWidth}px`;
                pill.style.transform = `translateX(${activeTab.offsetLeft}px)`;

                tabs.forEach((tab, i) => {
                        if (i === index) {
                                tab.classList.add('is-active');
                        } else {
                                tab.classList.remove('is-active');
                        }
                });

                updateSlideContent(index);

                currentIndex = index;
        }

	function startAutoplay() {
		slideInterval = setInterval(() => {
			let nextIndex = (currentIndex + 1) % tabs.length;
			updateSlider(nextIndex);
		}, intervalTime);
	}

	function resetAutoplay() {
		clearInterval(slideInterval);
		startAutoplay();
	}

	tabs.forEach((tab) => {
		tab.addEventListener('click', function () {
			const index = parseInt(this.getAttribute('data-index'));
			updateSlider(index);
			resetAutoplay();
		});
	});

	setTimeout(() => {
		updateSlider(0);
		startAutoplay();
	}, 100);
});
